// extracted by mini-css-extract-plugin
export default {"input":"AcademyProjectField_input__3KcIK","removeButton":"AcademyProjectField_removeButton__2TlRC"};